import { create } from 'zustand';

interface AIAssistantStore {
  pendingSearchQuery: string | null;
  setPendingSearchQuery: (query: string | null) => void;
}

export const useAIAssistantStore = create<AIAssistantStore>((set) => ({
  pendingSearchQuery: null,
  setPendingSearchQuery: (query) => set({ pendingSearchQuery: query }),
}));
